export default __webpack_public_path__ + "static/media/opened.b7057982.svg";